/*
 * Napibela 1.0 — Barra fija de compra (solo movil)
 *
 * Muestra la barra cuando el formulario de compra real ya paso hacia arriba, y
 * la esconde cuando vuelve a estar a la vista. El agregar al carro no pasa por
 * aca: el boton de la barra es un submit asociado al mismo <form> (atributo
 * form=""), asi que lo maneja el <product-form> de Dawn.
 */
(function () {
  'use strict';

  function init(bar) {
    // Dawn reemplaza el interior de <product-info> al cambiar de variante, y
    // ahi la barra vuelve a nacer sin observers. La marca evita re-inicializar
    // la misma barra dos veces cuando eso no paso.
    if (bar.dataset.stickyReady === 'true') return;

    var form = document.getElementById(bar.dataset.form);

    // Sin formulario no hay nada que enviar: la barra seria un boton muerto.
    if (!form) {
      bar.remove();
      return;
    }

    bar.dataset.stickyReady = 'true';

    // La barra se muestra cuando el formulario quedo COMPLETAMENTE arriba del
    // viewport. Se resuelve leyendo la posicion en cada scroll y no con un
    // IntersectionObserver: el observer solo avisa cuando la interseccion cruza
    // el umbral, y con un salto grande de scroll (un ancla, volver atras, un
    // fling en el telefono) el form pasa de estar abajo del viewport a estar
    // arriba sin intersectar nunca. No llega el callback y la barra se queda
    // escondida. Verificado con Playwright: con scrollTo(0, 1400) el observer
    // no disparaba una sola vez.
    var pendiente = false;

    function actualizar() {
      pendiente = false;
      bar.hidden = form.getBoundingClientRect().bottom > 0;
    }

    function alScrollear() {
      // Una sola lectura de layout por frame; el handler de scroll dispara
      // muchas mas veces que eso.
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(actualizar);
    }

    addEventListener('scroll', alScrollear, { passive: true });
    addEventListener('resize', alScrollear, { passive: true });
    actualizar();

    // El precio de la barra es una copia del de la ficha. Cuando cambia la
    // variante, Dawn reescribe ese nodo y aca se replica; si no, la barra
    // muestra el precio de la variante que estaba al cargar la pagina.
    // Se copia el outerHTML y no el innerHTML porque el envoltorio
    // .napibela-price-inline es el que alinea precio y badge de descuento.
    var destino = bar.querySelector('[data-sticky-price]');
    var origen = document.querySelector(bar.dataset.priceSource);

    if (destino && origen) {
      new MutationObserver(function () {
        destino.innerHTML = origen.outerHTML;
      }).observe(origen, { childList: true, subtree: true, characterData: true });
    }
  }

  function scan() {
    document.querySelectorAll('[data-napibela-sticky-atc]').forEach(init);
  }

  scan();

  // Si Dawn rehace el bloque de producto (cambio de variante), la barra nueva
  // necesita sus observers. childList en product-info alcanza: es el nodo que
  // el tema reemplaza.
  document.querySelectorAll('product-info').forEach(function (info) {
    new MutationObserver(scan).observe(info, { childList: true, subtree: true });
  });
})();
